(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('ResponsabilityService', ResponsabilityService)

    /** @ngInject */
    function ResponsabilityService(HttpService) {
        const ResponsabilityService = {
            getAll: getAll
        }

        return ResponsabilityService;

        function getAll() {
            return HttpService.get('/responsibilities');
        }
    }
}());